import React, { useEffect, useState } from "react";
import { Container, Card, Table, Spinner } from "react-bootstrap";
import { db } from "../FireBase";
import { doc, getDoc } from "firebase/firestore";

const CancellationPolicy = () => {
  const [contactInfo, setContactInfo] = useState({});
  const [cancellationData, setCancellationData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchAllData = async () => {
    try {
      const contactRef = doc(db, "settings", "contact");
      const cancellationRef = doc(db, "settings", "cancellation");

      const [contactSnap, cancellationSnap] = await Promise.all([
        getDoc(contactRef),
        getDoc(cancellationRef),
      ]);

      if (contactSnap.exists()) setContactInfo(contactSnap.data());
      if (cancellationSnap.exists()) setCancellationData(cancellationSnap.data());
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  const renderPolicyTable = (data, label) => {
    if (!data?.enabled) {
      return (
        <p className="text-muted">
          Cancellation not available for <strong>{label}</strong> bookings.
        </p>
      );
    }

    if (!data.rules || data.rules.length === 0) {
      return <p>No cancellation rules defined for {label} bookings.</p>;
    }

    return (
      <Table striped bordered hover responsive className="mt-3">
        <thead>
          <tr>
            <th>Days Before Cancellation</th>
            <th>Refund Percentage (%)</th>
          </tr>
        </thead>
        <tbody>
          {data.rules
            .sort((a, b) => b.days - a.days)
            .map((rule, index) => (
              <tr key={index}>
                <td>{rule.days} day{rule.days > 1 ? "s" : ""} before</td>
                <td>{rule.refund}% refund</td>
              </tr>
            ))}
        </tbody>
      </Table>
    );
  };

  if (loading) {
    return (
      <Container className="p-4 text-center">
        <Spinner animation="border" />
        <p className="mt-3">Loading policy...</p>
      </Container>
    );
  }

  return (
    <Container className="p-3" style={{ marginBottom: "40px" }}>
      <Card className="shadow rounded-4 p-4 border-0">
        <Card.Body>
          <h2 className="mb-4 text-center">Cancellation & Refund Policy</h2>

          <section className="mb-4">
            <p style={{ textAlign: "justify" }}>
              We understand that travel plans may change. Below are our current
              cancellation and refund policies for each type of booking.
            </p>
          </section>

          {/* Rooms */}
          <section className="mb-5">
            <h5>Room Bookings</h5>
            {renderPolicyTable(cancellationData?.rooms, "Room")}
          </section>

          {/* Packages */}
          <section className="mb-5">
            <h5>Package Bookings</h5>
            {renderPolicyTable(cancellationData?.packages, "Package")}
          </section>

          {/* Rentals */}
          <section className="mb-5">
            <h5>Rental Bookings</h5>
            {renderPolicyTable(cancellationData?.rentals, "Rental")}
          </section>

          {/* Sightseeings */}
          <section className="mb-5">
            <h5>Sightseeing Bookings</h5>
            {renderPolicyTable(cancellationData?.sightseeings, "Sightseeing")}
          </section>

          <hr />

          <section className="mb-4">
            <h5>Refunds</h5>
            <ul>
              <li>
                Eligible refunds will be processed within 7–10 business days to
                the original payment method.
              </li>
              <li>
                Payment gateway or transaction fees are non-refundable.
              </li>
            </ul>
          </section>

          <section className="mb-4">
            <h5>Force Majeure</h5>
            <p style={{ textAlign: "justify" }}>
              Refunds may not apply for cancellations caused by natural
              disasters, government restrictions, or other circumstances beyond
              our control.
            </p>
          </section>

          <section className="mb-4">
            <h5>Need Help?</h5>
            <p style={{ textAlign: "justify" }}>
              For cancellation or refund queries, please contact us:
              <br />
              <strong>Email:</strong>{" "}
              <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
              <br />
              <strong>Phone:</strong>{" "}
              <a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>
            </p>
          </section>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CancellationPolicy;
